export default function ReadingPage() {
  return (
    <article className="paper-stack paper-measure">
      <h2 className="paper-type-page">Your reading</h2>
      <p className="paper-type-body">Small sessions add up.</p>
      <section className="paper-stack">
        <h3 className="paper-type-section">Recent activity</h3>
        <p className="paper-type-body">You read 48 pages of コンビニ人間.</p>
        <p className="paper-type-metadata">Japanese · September 5</p>
      </section>
    </article>
  )
}
